import {
  DomainAppMilestoneType,
  DomainOriginType,
} from "@porchpass/api-client";

export function shouldOpenDgaModal(
  status: string,
  createdOrigin?: string,
): boolean {
  if (createdOrigin !== DomainOriginType.OriginDGA) {
    return false;
  }

  if (
    status === DomainAppMilestoneType.AppMilestoneDraft ||
    status === DomainAppMilestoneType.AppMilestoneReopenedForEdit ||
    status === DomainAppMilestoneType.AppMilestoneAwaitingSignature
  ) {
    return true;
  }

  return false;
}
